import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-center" }

import SfxChip from "src/components/data-point/SfxChip.vue"
import { WorkStateTableRowElement } from "src/util/types/components/sfxTable"
import { computed, PropType } from "vue"
import { useI18n } from "vue-i18n"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxTableTdWorkState',
  props: {
  state: {
    type: Object as PropType<WorkStateTableRowElement>,
    required: true,
  },
},
  setup(__props) {

const props = __props

//endregion

//region Variables

const { t } = useI18n()

const stateLabel = computed(() => {
  switch (props.state.column) {
    case "unreviewed":
      return t("sfxTable.state_unreviewed")
    case "not_applicable":
      return t("sfxTable.state_not_applicable")
    case "accepted":
      return t("sfxTable.state_accepted")
    case "rejected":
      return t("sfxTable.state_rejected")
    default:
      return t("sfxTable.state_unknown")
  }
})

const stateColour = computed(() =>
  props.state.column === "unreviewed" ? "states-corrected" : "fun-label-and-icon"
)

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_td = _resolveComponent("q-td")!

  return (_openBlock(), _createBlock(_component_q_td, { class: "sfx-table__td" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(SfxChip, {
          label: stateLabel.value,
          color: stateColour.value,
          "text-color": "white"
        }, null, 8, ["label", "color"])
      ])
    ]),
    _: 1
  }))
}
}

})